import { CellValueChangedEvent, ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useCallback, useMemo } from "react";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { useTranslation } from "react-i18next";

const ROW_HEIGHT = 40;
const HEADER_HEIGHT = 40;
const MAX_HEIGHT = 300;
const MIN_HEIGHT = 150;


export interface CashboxTableCellDef {
    coins: number;
    quantity: number;
    isExtra?: boolean;
}

export interface CashboxTableProps {
    data: CashboxTableCellDef[];
    onDataChanged: (coins: number, newQuantity: number) => void;
    loading: boolean;
}

export default function CashboxTable({
    data,
    onDataChanged,
    loading
}: CashboxTableProps){
    const { t } = useTranslation();
    const tableHeight = useMemo(() => Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, ROW_HEIGHT * data.length + HEADER_HEIGHT + 10)), [data]);
    const { innerWidth } = useWindowSize();
    const isMobile = useMemo(() => innerWidth < 600, []);

    const columnDefs: ColDef<CashboxTableCellDef>[] = [
        { headerName: t('denomination'), field: 'coins', cellDataType: 'text', flex: 1 },
        {
            headerName: t('quantity'),
            field: 'quantity',
            editable: true,
            cellEditor: 'agNumberCellEditor',
            cellEditorParams: {
                min: 0,
                precision: 0
            },
            flex: 1
        },
        {
            headerName: t('value'),
            valueGetter: params => (params.data?.coins ?? 0) * (params.data?.quantity ?? 0),
            cellStyle: {
                fontWeight: 'bold',
                textAlign: 'end'
            },
            flex: 1,
            
        }
    ];

    const onCellValueChanged = useCallback((event: CellValueChangedEvent<CashboxTableCellDef, any>) => {
        onDataChanged(event.data.coins, event.newValue);
    }, [onDataChanged]);

    return (
        <div className="ag-theme-alpine w-100 overflow-auto" style={{height: tableHeight}}>
            <AgGridReact<CashboxTableCellDef>
                
                rowHeight={40}
                headerHeight={40}
                onCellValueChanged={onCellValueChanged}
                columnDefs={columnDefs}
                rowClassRules={{
                    "bg-danger bg-opacity-100": params => params.data?.isExtra == true
                }}
                singleClickEdit={isMobile}
                rowData={data}
                loading={loading}
            />
        </div>
    )
}